import React from 'react';
import { Box } from '@mui/material';
import { useGridApiContext } from '@mui/x-data-grid';
import { AdminInsightIdPicker } from '@/admin/shared/pickers/AdminInsightIdPicker';
import { useGetBrokerGroupQuery } from '@/admin/brokerGroups/api/brokerGroupsApi';

/**
 * Edits one of a row's Insight ids (AdminInsightIdPicker, from its primary broker group's
 * ledger's list). Picking one saves the cell.
 */
export const InsightIdEditCell = ({ id, field, value, row, fieldType }) => {
	const apiRef = useGridApiContext();
	// currentData, not data, so the previous primary's ledger isn't used while this one loads
	const { currentData: brokerGroup } = useGetBrokerGroupQuery(row.brokerGroupId, {
		skip: !row.brokerGroupId,
	});

	const handleChange = async (insightId) => {
		await apiRef.current.setEditCellValue({ id, field, value: insightId });
		apiRef.current.stopCellEditMode({ id, field });
	};

	return (
		<Box sx={{ width: '100%', px: 0.5 }}>
			<AdminInsightIdPicker
				ledger={brokerGroup?.ledger}
				fieldType={fieldType}
				// An id from the file is text; one that isn't a number shows as none
				value={Number(value) || null}
				onChange={handleChange}
			/>
		</Box>
	);
};
